import React from "react";
// @ts-ignore
import AnimatedNumber from "react-animated-number";
export const MonumentsAnimatedNumber = ({ cards }) => (<AnimatedNumber duration={400} stepPrecision={0} value={cards.size} component="span"/>);
